import { useEffect, useState } from 'react';

import { Spin, Tabs } from 'antd';
import axios from 'axios';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import Detail from './Detail';
import PPPageHeader from '../../../components/pageHeader/PPPageHeader';
import Facts from './Fact';
import Notes from './Notes';

const ALL_TABS = [
  { key: 'detail', label: 'Захиалгын мэдээлэл' },
  { key: 'fact', label: 'Баримт' },
  { key: 'note', label: 'Тэмдэглэл' },
];

const OrderDeliveryListWithDetail = (props) => {
  const history = useHistory();
  const { orderId } = useParams();
  const location = useLocation();
  const result = location.state?.result ?? [];

  const initialTab = new URLSearchParams(location.search).get('tab') || 'detail';
  const getValidKey = (key) => (ALL_TABS.find((i) => i.key === key) ? key : ALL_TABS[0].key);

  const [currentKey, setCurrentKey] = useState(() => getValidKey(initialTab));
  const [detail, setDetail] = useState({});
  const [detailLoading, setDetailLoading] = useState(false);

  useEffect(() => {
    getOrderDetail(orderId);
    //eslint-disable-next-line
  }, [orderId]);

  const getOrderDetail = (id, comment) => {
    setDetailLoading(true);
    axios
      .get(`/api/v1/request/${id}?type=delivery`)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          let res = data.result;
          res.warehouseOrders = getWarehouseList(res);
          res.branchOrders = getBranchList(res);
          setDetail(res);
        } else setDetail({});
      })
      .finally(() => setDetailLoading(false));
  };

  const getWarehouseList = (detail) => {
    let wh = [];

    let whObj = detail?.orders?.warehouseOrders;
    for (const key in whObj) {
      if (Object.hasOwnProperty.call(whObj, key)) {
        const element = whObj[key];
        const dtl = detail?.meta?.warehouse?.detail[key];
        wh.push({
          name: dtl?.name,
          code: key,
          addressName: dtl?.addressName,
          products: element,
        });
      }
    }
    return wh;
  };

  const getBranchList = (detail) => {
    let branch = [];

    let branchObj = detail?.orders?.branchOrders;
    for (const key in branchObj) {
      if (Object.hasOwnProperty.call(branchObj, key)) {
        const element = branchObj[key];
        const dtl = detail?.meta?.branches?.detail[key];
        branch.push({
          name: dtl?.name,
          code: key,
          phoneNumber: dtl?.phoneNumber,
          addressName: dtl?.addressName,
          products: element,
        });
      }
    }
    return branch;
  };

  const goBack = () =>
    history.push({
      pathname: '/merchant/order/delivery',
      search: location.state?.search,
    });

  const routes = [
    {
      to: {
        pathname: location?.state?.source ?? '/merchant/order/delivery',
        search: location.state?.search,
      },
      breadcrumbName: 'Хүргэлтийн захиалга',
    },
    {
      path: 'first',
      breadcrumbName: 'Захиалгын дэлгэрэнгүй',
    },
  ];

  const onChange = (key) => {
    setCurrentKey(key);
    history.replace({
      pathname: `/merchant/order/deliveries/${orderId}`,
      search: `?tab=${key}`,
      state: location.state,
    });
  };

  return (
    <div>
      <PPPageHeader
        title="Захиалгын дэлгэрэнгүй"
        breadcrumb={{
          routes,
        }}
        onBack={() =>
          history.push({
            pathname: '/merchant/order/delivery',
            search: location.state?.search,
          })
        }
      />
      <Tabs
        activeKey={currentKey}
        onChange={onChange}
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: '0', padding: '0 12px' }}
      />
      <Spin spinning={detailLoading}>
        {currentKey === 'detail' && (
          <Detail detail={detail} resultMeta={result?.meta} refreshOrderStatus={goBack} />
        )}
        {currentKey === 'fact' && <Facts facts={detail} getDetailData={getOrderDetail} />}
        {currentKey === 'note' && (
          <Notes notes={detail} getDetailData={() => getOrderDetail(orderId)} />
        )}
      </Spin>
    </div>
  );
};

export default OrderDeliveryListWithDetail;
